import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LOCAL_STORAGE_KEYS } from '../constants/local-storage-keys';
import { StorageService } from '../services/storage.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // Skip interceptor for certain URLs (like login, config, etc.)
  if (req.url.includes('/auth/login') || req.url.includes('/api/config')) {
    return next(req);
  }

  const storageService = inject(StorageService);

  // Get token from storage - try both localStorage and sessionStorage
  let token: string | null = null;

  try {
    // Try authInfo key in both storages
    const authInfo = storageService.getItem<{
      token?: string;
      Token?: string;
      accessToken?: string;
      access_token?: string;
    }>(LOCAL_STORAGE_KEYS.AUTH_INFO, 'both');

    if (authInfo) {
      token =
        authInfo.token || authInfo.Token || authInfo.accessToken || authInfo.access_token || null;
    }

    // Fallback: try 'user' key (legacy support)
    if (!token) {
      const userInfo = storageService.getItem<{
        token?: string;
        Token?: string;
        accessToken?: string;
        access_token?: string;
      }>('user', 'both');

      if (userInfo) {
        token =
          userInfo.token || userInfo.Token || userInfo.accessToken || userInfo.access_token || null;
      }
    }
  } catch {
    // Error getting token from storage - ignore
  }

  // If token exists, add it to the request
  if (token) {
    const clonedRequest = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });

    return next(clonedRequest);
  }

  // If no token, proceed with the original request
  return next(req);
};
